import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=e371e2d8&scoped=true&"
import script from "./pageLayout.vue?vue&type=script&lang=js&"
export * from "./pageLayout.vue?vue&type=script&lang=js&"
import style0 from "./pageLayout.vue?vue&type=style&index=0&id=e371e2d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e371e2d8",
  null
  
)

export default component.exports